import { FC } from 'react';
import { Dialog, DialogContent, Stack, Typography } from '@mui/material';
import HeartPulse from '@modules/Tributes/components/HeartPulse';

interface Props {
  open: boolean;
  onClose: () => void;
}

export const SavingTributeDialog: FC<Props> = (props) => {
  const { open } = props;

  return (
    <Dialog open={open} PaperProps={{ variant: 'elevation' }}>
      <DialogContent>
        <Stack p={{ xs: 4, sm: 8 }} gap={2}>
          <Typography variant="h1" fontSize={24} align="center" mb={2}>
            Saving your LGCY ...
          </Typography>
          <HeartPulse />
          <Typography variant="body2" align="center" color="textSecondary" fontSize={16}>
            Please be patient as we build your memorial timeline.
          </Typography>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
